import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InitService } from './modules/shared/init.service';
import { Constant } from './modules/shared/constants';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MsalRedirectComponent, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { SharedModule } from './modules/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TestComponent } from './test/test.component';
import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptor } from './loader/loaderInterceptor';
import { AdvisorsTreeFilterModule } from './modules/shared/advisors-tree-filter/advisors-tree-filter.module';



const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(_logLevel: LogLevel, message: string) {
  console.log(message);
}

export function initApp(initsvc: InitService) {
  return (): Promise<any> => {
    if (window.location.href.indexOf("4200") > 0) {
      return initsvc.getConfigLocal();
    } else {
      return initsvc.getConfig();
    }
  }
}

export const isInIframe = window !== window.parent && !window.opener;

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: Constant.config.clientId,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      authority: Constant.config.instance + Constant.config.tenant,
      knownAuthorities: [Constant.config.instance],
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE
    },
    system: {
      allowRedirectInIframe: isInIframe,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: true
      }
    }
  });
}



export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(Constant.config.apiBaseUrl, Constant.config.scopes);
  protectedResourceMap.set(Constant.config.apiEnvUrl, Constant.config.scopes);

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: (_authService: MsalService, state: { url: string }) => ({
      scopes: Constant.config.scopes,
      redirectStartPage: `${window.location.origin}/#${state.url}`
    }),
    loginFailedRoute: '/'
  };
}

@NgModule({
  declarations: [
    AppComponent,
    TestComponent,
    FilterDialogComponent,
    LoaderComponent
 
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AdvisorsTreeFilterModule,
    AppRoutingModule,
    SharedModule,
    MsalModule
    
  ],
  providers: [ 
  provideZoneChangeDetection({ eventCoalescing: true }),
  { provide: APP_INITIALIZER, useFactory: initApp, deps: [InitService], multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  { provide: MSAL_INSTANCE,useFactory: MSALInstanceFactory},
  { provide: MSAL_GUARD_CONFIG,useFactory: MSALGuardConfigFactory},
  { provide: MSAL_INTERCEPTOR_CONFIG,useFactory: MSALInterceptorConfigFactory},


  MsalService,
  MsalGuard,
  MsalBroadcastService
],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
